import * as React from "react";
import { Navigate, Route } from "react-router";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";

const Products = React.lazy(() => import("./Products"));
const ProductCreate = React.lazy(() => import("./ProductCreate"));
const ProductView = React.lazy(() => import("./ProductView"));
const ProductEdit = React.lazy(() => import("./ProductEdit"));
const ProductsImport = React.lazy(() => import("./Importer/ProductImport"));
const ProductBackorders = React.lazy(() => import("./Backorders/ProductBackorders"));
const ProductsMerge = React.lazy(() => import("./Merge/ProductsMerge"));

export default function ProductIndex(): React.ReactNode {
    return [
        <PermissionRoute
            permissions={[ "see_products" ]}
            title="Products | Shopfront"
            path="/products"
            key="products"
            element={<Products />}
        />,
        <PermissionRoute
            permissions={[ "see_products", "edit_products", "edit_barcodes" ]}
            title="Merge Products | Shopfront"
            path="/products/merge"
            key="products-merge"
            element={<ProductsMerge />}
        />,
        <PermissionRoute
            permissions={[ "create_products" ]}
            title="Import Products | Shopfront"
            path="/products/import"
            key="products-imports"
            element={<ProductsImport />}
        />,
        <Route
            key="advanced-product-import-redirect"
            path="/products/import-advanced"
            element={(
                <Navigate
                    to="/products/import"
                    replace
                    state={{
                        mode: "advanced",
                    }}
                />
            )}
        />,
        <PermissionRoute
            permissions={[ "create_products" ]}
            title="Create Product | Shopfront"
            path="/product/new"
            key="product-create"
            element={<ProductCreate />}
        />,
        <PermissionRoute
            permissions={[ "view_product" ]}
            title="View Product | Shopfront"
            path="/product/:id"
            key="product-view"
            element={<ProductView />}
        />,
        <PermissionRoute
            permissions={[ "edit_products" ]}
            title="Edit Product | Shopfront"
            path="/product/:id/edit"
            key="product-edit"
            element={<ProductEdit />}
        />,
        <PermissionRoute
            permissions={[ "see_product_backorders" ]}
            title="Product Backorders | Shopfront"
            path="/backorders"
            key="product-backorders"
            element={<ProductBackorders />}
        />,
    ];
}
